
import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"
import {showSignUpModal} from "app/authentication/action"
import Auth_callback_queue from "app/authentication/callback_queue"


import I18n from "plugins/i18n-js"


interface InputOptions {
  show_auth_modal_on_fail?: boolean,
}
interface Options {
  show_auth_modal_on_fail: boolean,
}
const DEFAULT_OPTIONS: Options = {
  show_auth_modal_on_fail: true,
}

/*
# Shortlist the listing if authenticated
# If failed (not authenticated), queue it
#
# @param show_auth_modal_on_fail
#   if false, won't show modal after fail (not auth)
*/
const shortlist = (listing_id: string, options?: InputOptions) => {
  const opts: Options = Object.assign({}, DEFAULT_OPTIONS, options)

  q_ajax_3(
    {
      url:   `/${I18n.locale}/listings/${listing_id}/shortlist`,
      type:  "POST",
    },
    {
      error_tracking_options: {
        endpoint_identifier: "app/assets/javascripts/app/listings/shortlist#shortlist",
      },
    },
  )
  .catch(({response}) => {
    if (response.status === 401){
      Auth_callback_queue.add(() => {
        shortlist(listing_id)
      }, `app/listings/${listing_id}/shortlist`)

      if (opts.show_auth_modal_on_fail) {
        showSignUpModal()
      }
    }
  })
}

export default shortlist
